export default __webpack_public_path__ + "static/media/temp.5ae9eb56.svg";